/**
 * goTo
 * web 接口实现
 */
import { checkWebxParams } from '@didi/webx-js-core';
import { xenv } from '../xenv';
import { doCommonJump } from './goToCommonJump';
import { doDchn } from './goToDodchn';
import { getGoToParams } from './goToParams';
const host = {
    online: 'https://api.didi.cn',
    offline: 'https://v-test.intra.xiaojukeji.com',
    preline: 'https://vstage-pre.intra.xiaojukeji.com',
    simline: 'https://vstage-sim.intra.xiaojukeji.com' // qasim环境
};
let apiEnv = host['online'];
let currentxenv = 'h5';
let commonParams = {}; // 链接透传公参目前为空，预留方便后面扩展
export const goTo = (loadParams, env = 'online') => {
    apiEnv = host[env];
    currentxenv = xenv() || currentxenv;
    commonParams = Object.assign(commonParams, {
        xenv: currentxenv
    });
    let checkRst = checkWebxParams(loadParams);
    let querryParams = Object.assign({}, commonParams, loadParams.params);
    console.log('=== enterance ===', xenv(), doCommonJump);
    if (checkRst.isWebx) {
        doDchn(loadParams, currentxenv, apiEnv, querryParams).then(() => { })
            .catch(err => {
            console.log(err, 'webx 跳转失败 将走普通跳转');
            doCommonJump(loadParams, currentxenv, querryParams);
        });
    }
    else {
        doCommonJump(loadParams, currentxenv, querryParams);
    }
};
export { getGoToParams };
